import { render, staticRenderFns } from "./WorkflowInvocationOverview.vue?vue&type=template&id=638ec563"
import script from "./WorkflowInvocationOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowInvocationOverview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports